import { render } from "./CustomerBpmSearch.vue?vue&type=template&id=3839ecfc"
import script from "./CustomerBpmSearch.vue?vue&type=script&lang=js"
export * from "./CustomerBpmSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__